import { DropdownIndicatorProps, GroupBase, components } from "react-select";
import { SelectItem } from "../Select";
import Icon from "../../icon/Icon";

const DropdownIndicator = (
  props: DropdownIndicatorProps<SelectItem, false, GroupBase<SelectItem>>,
) =>
  props.selectProps.menuIsOpen ? (
    <components.DropdownIndicator {...props}>
      <Icon name="chevron-up" size="small" />
    </components.DropdownIndicator>
  ) : (
    <components.DropdownIndicator {...props}>
      <Icon name="chevron-down" size="small" />
    </components.DropdownIndicator>
  );

export default DropdownIndicator;
